export default {"src":"/_next/static/media/icon_shield_checkmark.21e11685.svg","height":19,"width":17,"blurWidth":0,"blurHeight":0};